var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.604924 11.3685C0.473939 11.5 0.40039 11.6779 0.40039 11.8635C0.40039 12.0491 0.473939 12.2271 0.604924 12.3585L11.2228 22.9764C11.4799 23.2353 11.8293 23.3815 12.1942 23.3828C12.5591 23.3841 12.9095 23.2404 13.1684 22.9833C13.4273 22.7262 13.5735 22.3768 13.5748 22.0119C13.5761 21.647 13.4324 21.2966 13.1753 21.0377L4.50992 12.3585C4.37894 12.2271 4.30539 12.0491 4.30539 11.8635C4.30539 11.6779 4.37894 11.5 4.50992 11.3685L13.2405 2.62418C13.4658 2.36114 13.5835 2.02279 13.5701 1.67673C13.5568 1.33068 13.4133 1.00241 13.1684 0.75753C12.9235 0.512649 12.5953 0.369192 12.2492 0.355825C11.9032 0.342458 11.5648 0.460166 11.3018 0.685428L0.604924 11.3685Z","fill":"#FEFEFE"}));
}

ChevronLeft.defaultProps = {"width":"14","height":"24","viewBox":"0 0 14 24","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
